// src/components/ProductsList/ProductsList.js
import React, { useEffect, useState } from "react";
import { database } from "../../firebase";
import { ref as dbRef, onValue } from "firebase/database";
import "./ProductsList.css";

export default function ProductsList({ onAddToCart }) {
  const [products, setProducts] = useState([]);

  useEffect(() => {
    const productsRef = dbRef(database, "products");
    onValue(productsRef, (snapshot) => {
      const data = snapshot.val();
      if (data) {
        const list = Object.entries(data).map(([id, value]) => ({
          id,
          ...value,
        }));
        setProducts(list);
      } else {
        setProducts([]);
      }
    });
  }, []);

  return (
    <section className="products-list">
      <h2>Our Products</h2>
      <div className="product-grid">
        {products.map((product) => (
          <div className="product-card" key={product.id}>
            <img
              src={product.image || "/images/placeholder.png"}
              alt={product.name}
            />
            <h3>{product.name}</h3>
            <p>{product.description}</p>
            <div className="price">₹{product.price}</div>
            <button
              className="add-to-cart-btn"
              onClick={() => onAddToCart(product)}
            >
              Add to Cart
            </button>
          </div>
        ))}
      </div>
    </section>
  );
}
